module.exports = __webpack_public_path__ + "img/cia_de_talentos.6feb7d14.svg";